import api from "../../service";
import middleware from "../../middleware";

class ThemeService extends middleware {
	constructor() {
		super();
		this.url = `${api.defaults.baseURL}/journal/theme`
	}

	async create(data) {
		const response = await api.post(`${this.url}`, data);
		return response;
	}

	async update(id, data) {
		try {
			const response = await api.put(`${this.url}/${id}`, data);
			return response;
		} catch (error) {
			console.log(error.response.data.message);
		}
	}

	async updateStatus(id, data) {
		try {
			const response = await api.put(`${this.url}/pause/${id}`, data);
			return response;
		} catch (error) {
			console.log(error.response.data.message);
		}
	}

	async delete(id) {
		const response = await api.delete(`${this.url}/${id}`);
		return response;
	}

	async getAll() {
		const response = await api.get(`${this.url}s`);
		return response;
	}

	async getByType({status = "active", type}) {
		console.log(status)
		console.log(type)
		const response = await api.get(`${this.url}s/byType/${type}`, {
			params: {
				...api.params,
				"status": status,
			},
		});
		return response;
	}

	async get(id) {
		const response = await api.get(`${this.url}/${id}`);
		return response;
	}
}

export default ThemeService
